import React, { PureComponent } from "react";
import { Field, reduxForm } from "redux-form";
import EyeIcon from "mdi-react/EyeIcon";
import KeyVariantIcon from "mdi-react/KeyVariantIcon";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import client from "../../../../shared/api-client";

class AcceptInvitationForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
  };

  state = {
    showPassword: false,
    showConfirmPassword: false,
    validToken: false,
    loading: true,
    passwordSet: false,
    password: "",
    confirm_password: "",
    error_message: "",
    adminToken: "",
    adminId: "",
    tokenExpired: false,
  };

  componentDidMount() {
    this.validateToken(this.props.token);
  }

  validateToken = (token) => {
    client(`admin/validate`, {
      method: "POST",
      body: {
        token: token,
      },
    }).then(
      (response) => {
        if (response._user_message_type === "error") {
          this.setState({
            tokenExpired: true,
            loading: false,
            validToken: false,
            error_message: response._user_message[0],
          });
        } else if (
          response.admin_token === undefined ||
          response.auth_adminid === undefined
        ) {
          this.setState({
            tokenExpired: true,
            loading: false,
            validToken: false,
            error_message: response._user_message,
          });
        } else {
          this.setState({
            validToken: true,
            loading: false,
            adminToken: response.admin_token,
            adminId: response.auth_adminid,
          });
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };

  onSubmit = () => {
    if (this.state.password.trim() === "") {
      this.setState({ error_message: "Please enter the password." });
    } else if (
      this.state.password.trim() !== this.state.confirm_password.trim()
    ) {
      this.setState({ error_message: "Confirm password does not matched." });
    } else if (this.state.password.trim().length < 8) {
      this.setState({ error_message: "Password must be min 8 characters." });
    } else {
      this.setPassword();
    }
  };

  setPassword = () => {
    client(`/admin_profile.php`, {
      method: "PUT",
      body: {
        password: this.state.password,
      },
      headers: {
        "X-Admin-Token": this.state.adminToken,
        "X-Auth-AdminID": this.state.adminId,
      },
    }).then(
      (response) => {
        this.setState({ passwordSet: true });
      },
      (error) => {
        this.setState({ show: true, errors: error._user_message });
      }
    );
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val });
  };

  render() {
    return this.state.passwordSet ? (
      <div className="form">
        <div className="form__form-group">
          <span className="form__form-group-label colorWhite">
            Account activated successfully.
          </span>
        </div>
        <div className="account__btns">
          <Link className="btn btn-primary account__btn" to="/">
            Login
          </Link>
        </div>
      </div>
    ) : this.state.loading ? (
      "Validating invitation url ..."
    ) : this.state.tokenExpired ? (
      <div className="form">
        <div className="errorMessage">{this.state.error_message}</div>
      </div>
    ) : this.state.validToken ? (
      <div className="form">
        {this.state.error_message !== "" ? (
          <div className="errorMessage">{this.state.error_message}</div>
        ) : (
          ""
        )}
        <div className="form__form-group">
          <span className="form__form-group-label">Password</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <KeyVariantIcon />
            </div>
            <Field
              name="password"
              component="input"
              type={this.state.showPassword ? "text" : "password"}
              placeholder="Password"
              onKeyUp={this.formChangeHandler}
            />
            <button
              className={`form__form-group-button${
                this.state.showPassword ? " active" : ""
              }`}
              onClick={(e) =>
                this.setState({
                  showPassword: !this.state.showPassword,
                })
              }
            >
              <EyeIcon />
            </button>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">Confirm Password</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <KeyVariantIcon />
            </div>
            <Field
              name="confirm_password"
              component="input"
              type={this.state.showConfirmPassword ? "text" : "password"}
              placeholder="Password"
              onKeyUp={this.formChangeHandler}
            />
            <button
              className={`form__form-group-button${
                this.state.showConfirmPassword ? " active" : ""
              }`}
              onClick={(e) =>
                this.setState({
                  showConfirmPassword: !this.state.showConfirmPassword,
                })
              }
            >
              <EyeIcon />
            </button>
          </div>
        </div>
        <div className="account__btns">
          <button
            className="btn btn-primary account__btn"
            onClick={this.onSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    ) : (
      "Invalid Token"
    );
  }
}

export default reduxForm({
  form: "accept_invitation_form",
})(AcceptInvitationForm);
